<template>
  <div class="login-wrapper">
    <div class="header" >
      <img src="../assets/img/zflogo.png" alt="" class="zf-logo">
      <div class="header-right">
       <a href="http://demo.csz.emof.cn/web/" ><img src="../assets/img/hname.png" alt="" ></a>
        <!-- <a href="javascript:void 0" ><img src="../assets/img/hname.png" alt="" @click="tips"></a> -->
      </div>
    </div>
    <div class="login-box">
      <div style="width: 798px;margin: 0 auto ;position: relative;" >
        <h2>
          <img src="../assets/img/login-logo.png" alt="">
        </h2>
        <div class="login-info">
          <div class="login-type">
            <h3>登录</h3>
          </div>
          <div>
            <div class="login-input flex-center">
              <i>机构名称</i>
              <!--            <el-input v-model="account" placeholder="请输入机构名称" class="login-item"-->
              <!--                      style="width: 498px"></el-input>-->
              <el-autocomplete
                style="width: 498px"
                class="login-item"
                v-model="account"
                :fetch-suggestions="querySearch"
                placeholder="请输入机构名称"
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete>
            </div>
            <div class="login-input flex-center">
              <i>密码</i>
              <el-input type="password" v-model="password" placeholder="请输入登录密码(初始登录密码:123456)" class="login-item"
                        style="width: 498px"></el-input>
              <router-link to="/forget" class="link-text">忘记密码</router-link>
            </div>
            <div class="login-input flex-center">
              <i>验证码</i>
              <el-input v-model="code" placeholder="请输入验证码" class="login-item"></el-input>
              <div class="code-img" @click="refreshCode">
                <Sidentify :identifyCode="identifyCode"></Sidentify>
              </div>
            </div>
            <el-button type="primary" class="login-submit-btn" @click="login" :disabled="submitState">登 录
            </el-button>
          </div>

        </div>

      </div>
      <p class="flex-center between-box footer-text">
        <span>公益汇聚力量</span>
        <span>慈善人人参与</span>
      </p>

    </div>
    <div class="footer">
      <div class=" flex-center between-box" style="height: 150px;">
        <img src="../assets/img/footerlogo.png" alt="">
        <div class="f-center">
          <p>主办单位：北京市委社会工委市民政局</p>
          <p>执行单位：北京市社会组织管理中心 </p>
          <p>协办单位：北京市扶贫协作和支援合作工作领导小组办公室 中关村科技园区管理委员会 </p>
          <p>北京市妇女联合会 北京市红十字会 首都公益慈善联合会</p>
          <p>承办单位：北京知诚社会组织众扶发展促进会</p>
          <p>All Rights Reserved <a href="http://www.beian.gov.cn" style="color: rgb(255, 255, 255);">京ICP备17050284号-4</a><a data-v-6b5f4025="" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037048" target="_blank" style="color: rgb(255, 255, 255);"><img style="display: inline;margin-left: 20px;" src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802037048</a></p>
        </div>
        <img src="../assets/img/ggh.png" alt="" class="ggh">
      </div>
    </div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      width="789px"
      :before-close="handleClose">
      <p class="dialog-tips">
        <span>{{ account }}</span>您好，由于您是初次登陆，为了保障您的账号安全请修改密码后重新登录！
      </p>
      <div class="set-account">
        <div class="login-input flex-center">
          <i>手机号</i>
          <el-input v-model="phone" placeholder="请输入手机号" class="login-item"></el-input>
        </div>
        <div class="login-input flex-center">
          <i>验证码</i>
          <el-input v-model="smsCode" placeholder="请输入验证码" class="login-item"></el-input>
          <div class="code-text" @click="sendCode">
            {{ codeText }} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
          </div>
        </div>
<!--        <div class="login-input flex-center">-->
<!--          <i>初始密码</i>-->
<!--          <el-input type="password" v-model="oldPass" placeholder="请输入初始密码" class="login-item"></el-input>-->
<!--        </div>-->
        <div class="login-input flex-center">
          <i>新密码</i>
          <el-input type="password" v-model="newPass" placeholder="请输入新密码" class="login-item"></el-input>
        </div>
        <div class="login-input flex-center">
          <i>确认密码</i>
          <el-input type="password" v-model="rnewPass" placeholder="请确认密码" class="login-item"></el-input>
        </div>
      </div>

      <div class="flex-center between-box dialog-btn">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="setSubmit">确 定</el-button>
      </div>


    </el-dialog>
  </div>
</template>

<script>
import Sidentify from '../components/identify'

export default {
  name: "login",
  data() {
    return {
      account: '',
      password: '',
      code: '',
      identifyCode: '',
      identifyCodes: '123456789ABCDEFGHJKLMNPQRSTUVWXYZ',
      phone: '',
      oldPass: '',
      newPass: '',
      rnewPass: '',
      smsCode: '',
      codeText: '获取验证码', // 验证码文字
      id: null, // 计时器id
      timeId: null, // 一次性计时器id
      submitState: false,
      dialogVisible: false,
      restaurants: [
      ],
    }
  },
  created() {
    this.refreshCode()
    this.$api.apiContent.allUser().then(res=>{
      res.data.map(item=>{
        this.restaurants.push({
          value:item.name
        })
      })

    })
  },
  methods: {
    tips(){
      this.$message.info('2020年北京公益慈善汇展官网正在研发中，敬请期待！')
    },
    querySearch(queryString, cb) {
      console.log(queryString)
      console.log(cb)
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    handleSelect(item) {
      console.log(item);
    },




    setSubmit() {
      this.submitState = true
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (!this.smsCode) {
        this.$message.error('请输入验证码')
        this.submitState = false
        return
      }
      // if (!this.oldPass) {
      //   this.$message.error('请输入初始密码')
      //   this.submitState = false
      //   return
      // }
      if (!this.newPass) {
        this.$message.error('请输入新密码')
        this.submitState = false
        return
      }
      if (this.newPass !== this.rnewPass) {
        this.$message.error('两次密码不一致')
        this.submitState = false
        return
      }
      this.$api.apiContent.setPass({
        token: this.$store.state.user.token,
        phone: this.phone,
        code: this.smsCode,
        // oldpass: this.oldPass,
        pass: this.newPass,
        repass: this.rnewPass,
      }).then(() => {
        this.$store.state.user = null
        this.$message({
          message: '修改成功,请重新登录',
          type: 'success',
          duration: 2000
        });
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }).catch(e => {
        this.$message.error(e.msg)
        this.submitState = false
      })
    },
    //  获取验证码
    sendCode() {
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
        this.codeText = 60
        this.id = setInterval(() => {
          if (this.codeText === 0) {
            this.codeText = '重新发送'
            clearInterval(this.id)
            return
          }
          if (typeof this.codeText === 'number') {
            this.codeText--
          }
        }, 1000)
        this.$api.apiContent.sendMsg({
          phone: this.phone,
          token: this.$store.state.user.token,
        }).then().catch(e => {
          this.$message.error(e.msg)
          this.codeText = '重新发送'
          clearInterval(this.id)
        })
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.submitState = false
    },
    login() {
      this.submitState = true
      if (!this.account) {
        this.$message.error('请输入帐号')
        this.submitState = false
        return
      }
      if (!this.password) {
        this.$message.error('请输入登录密码')
        this.submitState = false
        return
      }
      if (!this.code) {
        this.$message.error('请输入验证码')
        this.submitState = false
        return
      }
      this.$api.apiContent.passLogin({
        user_name: this.account,
        pass: this.password,
      }).then(res => {
        this.$store.state.user = res.data
        this.submitState = false
        // window.localStorage.setItem('user', JSON.stringify(res.data))
        if (res.data.phone) {
          this.$message({
            message: '登录成功',
            type: 'success',
            duration: 1000
          });
          setTimeout(()=>{
            this.$router.push('/home')
          },500)

        } else {
          this.dialogVisible = true
        }

      }).catch(e => {
        this.$message.error(e.msg)
        this.submitState = false
      })
    },
    /*
    * 生成验证码
    * */
    randomNum(min, max) {

      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCode, 4)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, 33)
          ]
      }
    }
  },
  components: {
    Sidentify
  },
  watch:{
    dialogVisible(){
      if(!this.dialogVisible){
        this.$store.state.user = null
      }
    }
  }
}
</script>

<style lang="scss">
.login-wrapper {
  width: 100%;

  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 92px;
    padding: 0 60px;
    border-bottom: 4px solid #d50000;
    overflow: hidden;
    .zf-logo{
      display: block;
    }
    .header-right{
      img{
        position: relative;
        top: 10px;
        display: block;
        height: 85px;
        margin-top: 10px;
      }
    }
  }
  .login-box {
    width: 100%;
    min-height: 750px;
    margin: 0 auto;
    padding-top: 50px;
    background: url(../assets/img/login.jpg) no-repeat center bottom;
    background-size: 100% 100%;

    h2 {
      text-align: center;
      margin-bottom: 40px;

      img {
        display: block;
        margin: 0 auto;
      }
    }

    .login-info {
      width: 100%;
      padding: 30px 50px;
      background: #fff;
      border-radius: 10px;

      .login-type {

        margin: 0 auto;

        h3 {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 24px;
          line-height: 36px;
          margin-bottom: 30px;
          cursor: pointer;
          position: relative;
        }
      }

      .login-input {
        height: 40px;
        border-radius: 4px;
        margin-bottom: 20px;

        i {
          display: block;
          width: 100px;
          text-align: right;
          padding-right: 15px;
        }

        .login-item {
          width: 360px;

          input {
            background: transparent;

          }
        }

        .link-text {
          display: block;
          width: 60px;
          height: 41px;
          text-align: left;
          line-height: 41px;
          background: #fff;
          margin: 0 20px;
          color: #f9aa0d;
        }

        .code-img {
          width: 116px;
          height: 41px;
          background: #fff;
          margin: 0 20px;
        }

      }

      .login-submit-btn {
        display: block;
        width: 300px;
        height: 50px;
        background-color: #f9aa0d;
        border-radius: 25px;
        font-size: 22px;
        border: 0;
        margin: 0 auto;
      }

      .to-setpass {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;

        .forget {
          color: #3b77e7;
        }
      }
    }
  }
  .footer{
    min-height: 180px;
    padding: 0 80px;
    background: #333333;
    border-top: 4px solid #000;
    img{
      display: block;
      max-height: 120px;
    }
    p{
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      color: #fff;
      img{
        margin-right: 5px;
      }
    }
  }

}

.dialog-tips {
  text-align: center;
  line-height: 40px;
  margin-bottom: 20px;

  span {
    color: #f9aa0d;
  }
}

.dialog-btn {
  width: 400px;
  margin: 30px auto 0;

  .el-button {
    width: 180px;
  }
}

.set-account {
  .login-input {
    height: 40px;
    border-radius: 4px;
    margin-bottom: 20px;

    i {
      display: block;
      width: 100px;
      text-align: right;
      padding-right: 15px;
    }

    .login-item {
      flex: 1;

      input {
        background: transparent;

      }
    }

    .link-text {
      display: block;
      width: 60px;
      height: 41px;
      text-align: left;
      line-height: 41px;
      background: #fff;
      margin: 0 20px;
      color: #f9aa0d;
    }

    .code-img {
      width: 116px;
      height: 41px;
      background: #fff;
      margin: 0 20px;
    }

    .code-text {
      width: 116px;
      height: 41px;
      text-align: center;
      line-height: 41px;
      color: #fff;
      background: #f9aa0d;
      margin: 0 20px;
      border-radius: 5px;
      cursor: pointer;
      overflow: hidden;
    }
  }

}
.footer-text{
margin:  80px  auto;
  width: 400px;
  font-size: 24px;
  color: #f9aa0d;
}
</style>


